import { useApp } from '@packages/hooks/useApp';
import { NotificationServiceProvider } from '@packages/notifications';
import { createMemo } from '@packages/react';
import { useSnackbar } from 'notistack';

export const RegisterNotificationEngine = createMemo(
    () => {
        const notify = useApp(NotificationServiceProvider);
        notify.engine = useSnackbar();

        return null;
    },
    {
        displayName: 'RegisterNotificationEngine',
    },
);
